import Cookies from 'js-cookie';
import isObject from 'lodash/isObject';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { QueryParams } from '@yme/common/constants';
import { getRootPath } from '@yme/components/CheckoutForm/PaymentSteps/selectors';
import { getSelectYourModelModalLabels } from '@yme/modals/SelectYourModelModal';
import { setIsModalShowed } from '@yme/modals/actions';
import { MODALS } from '@yme/modals/constants';
import { COOKIE_HYPERDRIVE_SELECTED_UNIT } from '@yme/pdp-components/ProductCard/CardAccessories/constants';
import { useTranslation } from '@yme/services/i18n';
import { getQueryParamByName } from '@yme/utils/common';
import { ACCESSORIES_COMPATIBILITY_KEY } from '@yme/utils/constants';
import { getCurrentProductParameters } from './helpers';
export function useCompatibilityPanel({ selectModelProps, compatiblePanelAPI, }) {
    const { defaultStartYear, labels, categories, endpoints } = selectModelProps;
    const { compatibleProduct, setCompatibleProduct, isCheckboxChecked, setIsCheckboxChecked } = compatiblePanelAPI;
    const { t } = useTranslation();
    const languageRootPath = useSelector(getRootPath);
    const dispatch = useDispatch();
    const history = useHistory();
    const onApplyProductToFilter = () => {
        setIsCheckboxChecked(!isCheckboxChecked);
        if (compatibleProduct && isObject(compatibleProduct)) {
            setCompatibleProduct({
                ...compatibleProduct,
                isCompatibleChecked: !isCheckboxChecked,
            });
        }
    };
    const onResetProduct = () => {
        if (compatibleProduct) {
            setCompatibleProduct('');
        }
        localStorage.removeItem(ACCESSORIES_COMPATIBILITY_KEY);
        Cookies.remove(COOKIE_HYPERDRIVE_SELECTED_UNIT, {
            path: `${languageRootPath}/`,
        });
        const queryParams = new URLSearchParams(history.location.search);
        const compatibleProductKeyByParam = getQueryParamByName(history.location.search, QueryParams.PRODUCT) || null;
        if (compatibleProductKeyByParam) {
            queryParams.delete(QueryParams.PRODUCT);
            history.push({
                search: queryParams.toString(),
            });
        }
    };
    const setCompatibilityProduct = (product) => {
        const currentParameters = getCurrentProductParameters(product);
        setCompatibleProduct(currentParameters);
        if (product?.key) {
            const queryParams = new URLSearchParams(history.location.search);
            queryParams.set(QueryParams.PRODUCT, `${product.key}`);
            history.push({
                search: queryParams.toString(),
            });
        }
    };
    const modalLabels = getSelectYourModelModalLabels(labels);
    const openSelectModelModal = () => {
        if (selectModelProps) {
            dispatch(setIsModalShowed({
                type: MODALS.SELECT_YOUR_MODEL_MODAL,
                data: {
                    title: modalLabels.header,
                    endpoints,
                    categories,
                    labels: modalLabels,
                    callback: setCompatibilityProduct,
                    defaultStartYear,
                    isAnalyticTracked: true,
                    primaryButtonContent: t('common_confirm_button'),
                    secondaryButtonContent: t('common_cancel_button'),
                },
            }));
        }
    };
    const onChangeCheckbox = () => {
        openSelectModelModal();
    };
    return {
        onApplyProductToFilter,
        modalLabels,
        openSelectModelModal,
        onChangeCheckbox,
        onResetProduct,
        // Compatibility feature props
        compatibleProduct,
        setCompatibleProduct,
        isCheckboxChecked,
        setIsCheckboxChecked,
    };
}
